import Card from '@/components/Card';
import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { BookUser, MapPinHouse, Timer } from 'lucide-react';

type HopType = {
  name: string | null;
  address: string;
  latency: string[];
  hop: number;
};

function RouteDescription(props: { route: HopType }) {
  const theme = useTheme();
  return (
    <Card sx={{ marginTop: '16px' }}>
      <Stack direction="column" spacing={2}>
        {/** Hop address name */}
        {props.route.name !== null && (
          <Stack direction="row" spacing={2}>
            <BookUser color={theme.palette.primary.main} />
            <Typography variant="h6">{props.route.name}</Typography>
          </Stack>
        )}
        {/** Hop IP address */}
        <Stack direction="row" spacing={2}>
          <MapPinHouse color={theme.palette.primary.main} />
          <Typography variant="body1">{props.route.address}</Typography>
        </Stack>
        {/** Hop latency array */}
        <Stack direction="row" spacing={2}>
          <Timer color={theme.palette.primary.main} />
          <Typography variant="body1">
            {props.route.latency.join(' / ')}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
}

export default RouteDescription;
